import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import TitleFilter from 'components/form/filters/TitleFilter';

const ProductFilters = (props) => {
    const {
        actionType,
        location,
        resource,
    } = props;

    const filters = {
        basic: {
            title: {
                component: TitleFilter,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        actionType={ actionType }
        location={ location }
        resource={ resource }
        filters={ filters }
    />;
};

ProductFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default ProductFilters;



// WEBPACK FOOTER //
// ./src/pages/products/productRelated/ProductFilters.js